<td-address-page scope="delegators" #page *transloco="let t">
    <h1 my-title>{{ t('delegators-list.title-my') }}</h1>
    <span other-subtitle>{{ t('delegators-list.title-delegated-by') }}</span>

    <td-delegator-table class="mt-3" *ngIf="page.validAddress" [address]="page.address"></td-delegator-table>
</td-address-page>
